var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.999,
    height: 26.153,
    viewBox: "0 0 105.999 26.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670",
    transform: "translate(-756.001 -614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3632",
    "data-name": "Group 3632",
    transform: "translate(766.001 613.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    "data-name": "Path 2984",
    d: "M110.666,3.794a5.172,5.172,0,0,1,1.222-1.937,4.786,4.786,0,0,1,7.527,1.118c1.153,2.1,2.375,4.15,3.562,6.225,1.983,3.447,3.988,6.893,5.948,10.352a4.765,4.765,0,1,1-8.334,4.622q-2.611-4.548-5.233-9.084a1.041,1.041,0,0,0-.127-.184,1.877,1.877,0,0,1-.38-.565c-.772-1.36-1.568-2.709-2.34-4.058-.5-.876-1.014-1.741-1.51-2.617a4.773,4.773,0,0,1-.634-2.536,3.534,3.534,0,0,1,.3-1.337",
    transform: "translate(-110.926 0)",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M13.284,42.493a6.625,6.625,0,0,0-.219,1.268,4.98,4.98,0,0,0,.692,2.709q1.9,3.268,3.793,6.559c.115.2.207.392.323.576-.692,1.2-1.383,2.386-2.086,3.585-.968,1.671-1.937,3.354-2.916,5.026-.046,0-.058-.023-.069-.058a.714.714,0,0,1,.046-.265,4.639,4.639,0,0,0-1.107-4.576A4.394,4.394,0,0,0,9.03,55.922a4.678,4.678,0,0,0-3.7,1.026c-.2.15-.323.369-.553.484a.077.077,0,0,1-.081-.058c.553-.957,1.1-1.914,1.648-2.87Q9.768,48.556,13.2,42.62c.023-.046.058-.081.081-.127",
    transform: "translate(-13.544 -38.699)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M-8.8,213.863c.219-.2.427-.4.657-.588a4.765,4.765,0,0,1,7.62,2.893,5.067,5.067,0,0,1-.184,2.455,1.2,1.2,0,0,1-.046.2c-.1.184-.2.38-.311.565a4.635,4.635,0,0,1-4.519,2.409,4.732,4.732,0,0,1-4.369-4.127A4.613,4.613,0,0,1-9.32,214.6c.115-.208.254-.392.38-.6.058-.046.035-.138.138-.138",
    transform: "translate(0 -195.153)",
    fill: "#34a853"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Google_Ads",
    "data-name": "Google Ads",
    transform: "translate(792 632)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google Ads")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsLogo);
export default __webpack_public_path__ + "static/media/adsLogo.4b013ece.svg";
export { ForwardRef as ReactComponent };